import React, { ReactNode, useState } from 'react';
import { LockClock, Money } from '@mui/icons-material';
import { Button, CircularProgress, Stack } from '@mui/material';
import { ChangeLogCard, LenderDeskingPanel } from 'modules/creditSubmission';
import { CardContainer } from 'components/shared/CardContainer/CardContainer';
import { RenderWithFallback } from 'components/shared/Conditional/RenderWithFallback';
import { LenderDeskingPanelProps } from 'modules/creditSubmission/lenderDeskingPanel/types';

interface Props {
  isCreditAppLoading: boolean;
  isLoadingEquipmentData: boolean;
  isLoadingCreditSubmissionData: boolean;
  lenderDeskingPanelProps: LenderDeskingPanelProps;
}

export const DecisionTab = ({
  isCreditAppLoading,
  isLoadingEquipmentData,
  lenderDeskingPanelProps,
  isLoadingCreditSubmissionData,
}: Props) => {
  const [renderType, serRenderType] = useState<'desking' | 'log'>('desking');

  const render: Record<'desking' | 'log', ReactNode> = {
    desking: <LenderDeskingPanel {...lenderDeskingPanelProps} />,
    log: <ChangeLogCard csId={lenderDeskingPanelProps.cs.creditSubmissionId} />,
  };

  const renderBtn: Record<'desking' | 'log', ReactNode> = {
    desking: (
      <Button size="small" onClick={() => serRenderType('log')} variant="text" startIcon={<LockClock />}>
        Audit Log
      </Button>
    ),
    log: (
      <Button size="small" onClick={() => serRenderType('desking')} variant="text" startIcon={<Money />}>
        Desking
      </Button>
    ),
  };

  return (
    <CardContainer>
      <RenderWithFallback
        isLoading={isCreditAppLoading || isLoadingCreditSubmissionData || isLoadingEquipmentData}
        fallBack={
          <Stack height="100%" alignItems="center" justifyContent="center" gap="1rem">
            <CircularProgress />
          </Stack>
        }
      >
        <Stack width="100%" alignItems="flex-end">
          {renderBtn[renderType]}
        </Stack>

        {render[renderType]}
      </RenderWithFallback>
    </CardContainer>
  );
};
